import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Badge, Col, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import EChartsReact from 'echarts-for-react';
// import AppContext from 'context/Context';
// import { graphic } from 'echarts';
// import { rgbaColor, themeColors } from 'helpers/utils';

const TotalsWidget = ({ searchedData, prevData, title, loading }) => {
    // const { config: { isDark } } = useContext(AppContext);
    const variant = prevData > 0 ? 'success' : 'danger';
    const icon = prevData > 0 ? 'caret-up' : 'caret-down';

    return (
        <Col xs='6' className='h-100'>
            <div className='flex-between-center row rounded-3 me-1 shadow-start-sm h-100'>
                <div className='d-flex d-lg-block flex-between-center col-sm-6'>
                    <h5 className="mb-md-0 mb-lg-2">Total {title}</h5>
                    {loading ? <Spinner animation="border" variant="primary" /> :
                        <div>
                            <h4 className="fs-4 fw-normal text-700 d-inline">
                                <span>
                                    {searchedData || 0}
                                </span>
                            </h4>
                            <small className='align-top'><Badge bg={variant} className='mb-md-0 mb-lg-2 ms-2'>
                                <FontAwesomeIcon icon={icon} className="me-1" />{prevData?.toFixed(2) || 0}%
                            </Badge></small>
                        </div>
                    }
                </div>
                {/* <div className="col-6">
                    <EChartsReact
                        style={{ height: '100%', width: '100%' }}
                        option={{
                            isLoading: loading,
                            series: [{
                                type: 'line',
                                smooth: true,
                                boundaryGap: false,
                                lineStyle: {
                                    color: rgbaColor(themeColors.primary, 1)
                                },
                                areaStyle: {
                                    color: new graphic.LinearGradient(0, 0, 0, 1, [
                                        {
                                            offset: 0,
                                            color: rgbaColor(themeColors.primary)
                                        },
                                        {
                                            offset: 1,
                                            color: isDark ? rgbaColor(themeColors.dark) : rgbaColor(themeColors.light)
                                        }
                                    ])
                                },
                                emphasis: {
                                    scale: true,
                                    scaleSize: 20,
                                },
                                data: graph || [],
                            }],
                            xAxis: {
                                type: 'category',
                                splitLine: { show: false },
                                axisLine: { show: false },
                                axisTick: { show: false },
                                axisLabel: { show: false }
                            },
                            yAxis: {
                                type: 'category',
                                splitLine: { show: false },
                                axisLine: { show: false },
                                axisTick: { show: false },
                                axisLabel: { show: false }
                            },
                            darkMode: isDark
                        }}
                    />
                </div>*/}
            </div>
        </Col>
    )
}

TotalsWidget.propTypes = {
    searchedData: PropTypes.number,
    prevData: PropTypes.number,
    // graph: PropTypes.array,
    title: PropTypes.string,
    loading: PropTypes.bool
};
export default memo(TotalsWidget);